import Sidebar from "../../../components/partials/Sidebar";
import Header from "../../../components/partials/Header";
import Breadcrumb from "../../../components/Breadcrumb";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Pagination from "../../../components/Pagination";
import "./style.css";
import filter from "../../../images/icons/filter.png";
import editIcon from "../../../images/icons/edit.png";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import Modal from "react-bootstrap/Modal";
import viewIcon from "../../../images/view.png";
import CustomerViews from "./view";
import CustomerAdd from "./Add";
import CustomerEdit from "./Edit";
import { apiCancelCustomer, apiListCustomer } from "../../../api/master";
import Swal from "sweetalert2";
import { removeEmptyFields } from "../../../utils";
import $ from "jquery";
import BulkUpload from "./BulkUpload";

function CustomerList() {
  const initialState = {
    customer_name: "",
    is_active: "",
    customer_mobile: "",
  };

  // const [stateValue,setStateValue] = useState([]);
  // const [city,setCity] = useState([]);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showId, setShowId] = useState(0);
  const [editId, setEditId] = useState("");

  const [formInputs, setFormInputs] = useState(initialState);
  const [filtersVisible, setFiltersVisible] = useState(false);

  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);

  async function changeStatus(cust_id, status) {
    let target = window.event.target;
    let oldText = target.innerText;
    target.innerText = "Updating...";
    await apiCancelCustomer({ cust_id: cust_id, is_active: status })
      .then((data) => {
        setError("");
      })
      .catch((err) => {
        setError(err.response.data.data.message);
        setTimeout(function () {
          setError("");
        }, 3000);
      })
      .finally(() => {
        target.innerText = oldText;
        getList(filtersVisible);
      });
  }

  async function getList(isFilter = true, pageNo = null) {
    let json = { paginate: 1, page_no: (pageNo || currentPage) - 1 };
    if (isFilter) {
      json = { ...json, ...formInputs };
    }
    json = removeEmptyFields(json);
    await apiListCustomer(json)
      .then((data) => {
        setCurrentPage(pageNo || currentPage);
        setIsSubmit(false);
        setList(data.data.data.list);
        setIsLoading(false);
        setTotalPage(data.data.data.count);
        setIsSubmit(false);
      })
      .catch(function (err) {
        setIsSubmit(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err.message,
          confirmButtonText: "OK",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          focusConfirm: true,
        });
      });

    // await apiState().then(result => setStateValue(result.data.data.list));
    // await apiCity().then(result => setCity(result?.data?.data.list));
  }

  useEffect(
    function () {
      getList(filtersVisible);
    },
    [currentPage]
  );

  function handleInputs(e) {
    setFormInputs({ ...formInputs, [e.target.id]: e.target.value });
  }

  function handleFilterVisibility() {
    if (filtersVisible) {
      setFiltersVisible(false);
      setFormInputs(initialState);
    } else {
      setFiltersVisible(true);
    }
  }
  const handlePaste = (event) => {
    const pastedText = event.clipboardData.getData("text/plain");
    const onlyNumbers = pastedText.replace(/\D/g, "");
    event.preventDefault();
    document.execCommand("insertText", false, onlyNumbers);
  };

  let lastKey = null;
  function inputNumber(e) {
    let allowKeys = [
      "Tab",
      "Backspace",
      "Delete",
      "Enter",
      "ArrowUp",
      "ArrowDown",
      "ArrowLeft",
      "ArrowRight",
      "Control",
    ];

    if (
      (e.ctrlKey || e.metaKey) &&
      ["c", "x", "v", "a"].includes(e.key.toLowerCase())
    ) {
      return true;
    }

    if (!($.isNumeric(e.key) || allowKeys.includes(e.key))) {
      e.preventDefault();
    }

    lastKey = e.key;
  }

  return (
    <>
      <div
        className="d-flex min-vh-100 main-Wrapper"
        style={{ background: "#DAE5FF" }}
      >
        <Sidebar />
        <div className="content m-1 p-2">
          <Header />
          <main className="bg-white rounded-4" id="buyer">
            <div className="container-fluid p-2">
              <div className="row">
                <div className="col">
                  <Breadcrumb path={["Customer"]} />
                </div>
                <div
                  className="col text-end"
                  style={{
                    display: "flex",
                    alignItems: "end",
                    justifyContent: "end",
                  }}
                >
                  <Tippy content="Filter">
                    <img
                      onClick={() => handleFilterVisibility()}
                      src={filter}
                      className="img-fluid me-3"
                      alt=""
                      role="button"
                      style={{ width: "2rem" }}
                    />
                  </Tippy>

                  <button
                    className="btn btn-secondary rounded-3 "
                    type="button"
                    style={{
                      height: "33px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginRight: "10px",
                    }}
                    onClick={() => {
                      handleShow();
                      setShowId(4);
                    }}
                  >
                    Upload Excel
                  </button>

                  <Link
                    onClick={(v) => {
                      handleShow();
                      setShowId(1);
                    }}
                    className="btn btn-primary px-4 py-2"
                    style={{
                      height: "33px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    Add Customer
                  </Link>
                </div>
              </div>

              {filtersVisible && (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    setIsSubmit(true);
                    currentPage > 1 ? setCurrentPage(1) : getList(true, 1);
                  }}
                  autoComplete="off"
                >
                  <div className="row" id="buyerAdd">
                    <div className="col-md">
                      <label htmlFor="customer_name">Customer Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="customer_name"
                        value={formInputs.customer_name}
                        onChange={handleInputs}
                      />
                    </div>
                    <div className="col-md">
                      <label htmlFor="customer_mobile">Mobile</label>
                      <input
                        type="text"
                        className="form-control"
                        id="customer_mobile"
                        maxLength={13}
                        onKeyDown={inputNumber}
                        onPaste={handlePaste}
                        value={formInputs.customer_mobile}
                        onChange={handleInputs}
                      />
                    </div>
                    <div className="col-md">
                      <label htmlFor="default_godown">Status</label>
                      <select
                        className="form-select"
                        value={formInputs.is_active}
                        onChange={handleInputs}
                        id="is_active"
                      >
                        <option value="">All</option>
                        <option value="1">Active</option>
                        <option value="0">In-Active</option>
                      </select>
                    </div>

                    <div
                      className="col-md-4 mt-auto"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "end",
                        float: "right",
                      }}
                    >
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmit}
                        style={{
                          height: "33px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          float: "right",
                        }}
                      >
                        {isSubmit && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Search
                      </button>
                      <button
                        className="btn btn-primary rounded-3 px-3 ms-2"
                        type="button"
                        onClick={(e) => {
                          setFormInputs(initialState);
                          currentPage > 1
                            ? setCurrentPage(1)
                            : getList(false, 1);
                        }}
                        style={{
                          height: "33px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          float: "right",
                          background: "#4263eb",
                          fontSize: "14px",
                        }}
                      >
                        Clear Filters
                      </button>
                    </div>
                  </div>
                </form>
              )}

              {error && (
                <div className="row mt-3">
                  <div className="col">
                    <div
                      className={`alert alert-danger py-1 small`}
                      role="alert"
                    >
                      {error || ""}
                    </div>
                  </div>
                </div>
              )}

              <div className="row mb-4">
                <div className="col">
                  <table className={`table ${error ? "my-1" : "mt-4"} rounded`}>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Customer Name</th>
                        <th>Customer Mobile</th>
                        <th>Customer Address</th>
                        {/* <th>State</th>
                        <th>City</th>
                        <th>Pincode</th> */}
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(isLoading || list.length == 0) && (
                        <tr>
                          <td colSpan="9" className="text-center">
                            {isLoading ? "Loading..." : "No Records"}
                          </td>
                        </tr>
                      )}
                      {list.map((v, i) => (
                        <tr key={`bl_` + i}>
                          <td>{currentPage * 10 - 10 + i + 1}</td>
                          <td>
                            {v?.customer_name?.length > 15
                              ? v?.customer_name?.substring(0, 15) + "..."
                              : v?.customer_name}
                          </td>
                          <td>{v.customer_mobile}</td>
                          <td>{v.cust_address}</td>
                          {/* <td>{stateValue?.find((el)=> el?.state_id === v?.cust_state_id)?.name}</td>
                          <td>{city?.find((el)=> el?.city_id === v.cust_city_id)?.city}</td>
                          <td>{v.cust_pincode}</td> */}
                          <td>
                            <Tippy content="Change Status">
                              {v.is_active ? (
                                <span
                                  className="badge text-bg-success"
                                  role="button"
                                  onClick={() => changeStatus(v.cust_id, 0)}
                                >
                                  Active
                                </span>
                              ) : (
                                <span
                                  className="badge text-bg-danger"
                                  role="button"
                                  onClick={() => changeStatus(v.cust_id, 1)}
                                >
                                  In-Active
                                </span>
                              )}
                            </Tippy>
                          </td>
                          <td>
                            <Tippy content="View" trigger="mouseenter">
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setEditId(v);
                                  handleShow();
                                  setShowId(3);
                                }}
                              >
                                <img
                                  src={viewIcon}
                                  className="img-fluid me-2"
                                  alt=""
                                />
                              </a>
                            </Tippy>

                            <Tippy content="Edit" trigger="mouseenter">
                              <Link
                                onClick={() => {
                                  setEditId(v);
                                  handleShow();
                                  setShowId(2);
                                }}
                                className={`link-info ${
                                  v.is_active ? "" : "d-none"
                                }`}
                              >
                                <img
                                  src={editIcon}
                                  className="img-fluid me-2"
                                  alt=""
                                />
                              </Link>
                            </Tippy>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <Pagination
                    nPages={Math.ceil(totalPage / 10)}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
              <Modal
                show={show}
                onHide={handleClose}
                keyboard={false}
                backdrop="static"
                size={showId == 4 ? "lg" : ""}
              >
                {showId == 1 ? (
                  <CustomerAdd id={editId} list={getList} hide={handleClose} />
                ) : showId == 2 ? (
                  <CustomerEdit id={editId} list={getList} hide={handleClose} />
                ) : showId == 3 ? (
                  <CustomerViews
                    id={editId}
                    list={getList}
                    hide={handleClose}
                  />
                ) : showId == 4 ? (
                  <BulkUpload list={getList} hide={handleClose} />
                ) : null}
              </Modal>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

export default CustomerList;
